import { WarningSign } from '../../UI';
import { aggregateWeekSeverity } from './kpiSeverity';
import type { WeekKpi } from './types';
import styles from './WeekKpiCell.module.css';

interface WeekWarningIconProps {
  kpi: WeekKpi;
}

export const WeekWarningIcon = ({ kpi }: WeekWarningIconProps) => {
  const severity = aggregateWeekSeverity(kpi);
  if (severity === 'OK') return null;

  return (
    <WarningSign
      variant={severity === 'EXCEEDED' ? 'error' : 'warning'}
      className={styles.warningIcon}
    />
  );
};
